
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Small_intestinal_neoplasm",
components: {
XTable
}
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Small_intestinal_neoplasm.vue